import { Component, EventEmitter, Output } from '@angular/core';
import { PieChartComponent } from '@swimlane/ngx-charts';

@Component({
  selector: 'fc-custom-pie-chart',
  templateUrl: './custom-pie-chart.component.html',
  styleUrls: ['./custom-pie-chart.component.scss'],
})
export class CustomPieChartComponent extends PieChartComponent {
  @Output() select = new EventEmitter<any>();

  onSelect(event: any) {
    this.select.emit(event);
  }
}
